import React from "react";

import GearIcon from "../../resources/landing-page/gear.svg";
import MergeIcon from "../../resources/landing-page/merge.svg";
import ShieldIcon from "../../resources/landing-page/shield.svg";
import MapIcon from "../../resources/landing-page/map-circle.png";
import SnowRemovalIcon from "../../resources/landing-page/snow-removal-circle.webp";
import SpreadsheetIcon from "../../resources/landing-page/icons/spreadsheet.webp";
import SiteMapIcon from "../../resources/landing-page/icons/sitemap.webp";
import VideoCard from "./components/VideoCard";
import DesktopMobileApp from "../../resources/landing-page/desktop-mobile-combined.png";

import LandingPageModal from "./components/LandingPageModal";
import MaxWidth from "./components/MaxWidth";
import ButtonLink from "../../components/Buttons/ButtonLink";
import ContactUsForm from "../../components/Form/ContactUsForm";
import Pricing from "../../components/Pricing";
import { useNavigate } from "react-router-dom";
import { AboutUsContent } from "./AboutPage";
const HomePage = () => {
  const [isPopupOpen, setIsPopupOpen] = React.useState(false);

  const handlePopupClick = (e) => {
    e.preventDefault();
    setIsPopupOpen(true);
  };

  return (
    <div className="flex flex-col text-lg lg:text-xl">
      <div className="h-full bg-full-black/30 bg-[url('./resources/landing-page/landing-page-02.jpg')] bg-cover p-4 lg:p-8 relative bg-blend-darken">
        <IntroductionSection popupClicked={handlePopupClick} />
      </div>
      <div className="bg-landing-page-black relative">
        <div className="absolute right-0 bg-[url('./resources/landing-page/snow-icon-white.svg')] bg-cover h-[600px] w-[800px] z-0 opacity-10"></div>
        {/* <TestimonialSection /> */}
        <HurdlesSection />
      </div>
      <div className="h-full bg-full-black/40 bg-[url('./resources/landing-page/grass.jpg')] bg-center bg-cover p-4 lg:p-8 relative bg-blend-darken">
        <BestLawnCareSection />
      </div>
      <div
        className="bg-landing-page-gray py-8 lg:py-20 bg-[url('./resources/landing-page/snow-icon-light-gray.svg')] bg-no-repeat font-bold"
        style={{ backgroundSize: "800px", backgroundPosition: "10%" }}
      >
        <HowDoesItWorkSection />
      </div>
      <div className="bg-landing-page-black p-8 py-16 pt-20 bg-repeat-x bg-[url('./resources/landing-page/snowflake-pattern.webp')]">
        <LearnMoreSection />
        <PricingSection />
      </div>
      <div
        id="about-us"
        className="h-full bg-full-white/60  bg-[url('./resources/landing-page/snow-road.jpg')] bg-center bg-cover p-4 pt-10 pb-20 relative bg-blend-lighten text-black flex flex-col items-center"
      >
        <h2 className="home-header font-extrabold mt-4 text-center text-[#186ac5] mb-4">
          About SnowScape
        </h2>
        <div className="max-w-6xl">
          <AboutUsContent />
        </div>
      </div>
      <div className="bg-landing-page-black p-8 py-16 pt-20 bg-repeat-x bg-[url('./resources/landing-page/snowflake-pattern.webp')]">
        <WhyChooseUsSection />
        <div className="flex justify-center my-4 lg:my-20" id="contact-us">
          <ContactUsForm />
        </div>
      </div>
      <div className="h-full bg-full-black/30 bg-[url('./resources/landing-page/snow-to-grass.jpg')] bg-center bg-cover p-4 lg:p-8 relative bg-blend-darken">
        <BothSeasonsCoveredSection />
      </div>
      <LandingPageModal
        open={isPopupOpen}
        closeModal={() => setIsPopupOpen(false)}
      />
    </div>
  );
};
const BothSeasonsCoveredSection = () => {
  return (
    <div className="min-h-[200px] lg:min-h-[400px] text-center">
      <MaxWidth>
        <h2
          className="home-header text-snow-white font-extrabold mt-4 uppercase text-center"
          style={{ textShadow: "1px 1px 2px #000000" }}
        >
          Both Seasons Covered
        </h2>
        <h3
          className="text-snow-white mt-4 font-bold lg:text-center"
          style={{ textShadow: "1px 1px 2px #000000" }}
        >
          Do you work year-round? SnowScape has you covered! Easily switch
          between seasons.
        </h3>
      </MaxWidth>
    </div>
  );
};
const HowDoesItWorkSection = () => {
  return (
    <>
      <h3 className="home-header text-[#186ac5] font-bold text-center leading-none">
        How Does It Work?
      </h3>
      <h4 className="text-landing-page-black font-normal text-center">
        Simple, to the point, and easy to onboard
      </h4>
      <div className="flex flex-col md:flex-row lg:max-w-4xl md:mx-auto px-4 justify-between items-center">
        <div className=" mt-8 lg:mt-4">
          <h5 className="text-landing-page-black font-bold">
            Admin Portal - Desktop Version
          </h5>
          <ol className="list-disc text-landing-page-black list-inside mt-4 font-normal">
            <li className="mb-1">Build routes to track work</li>
            <li className="mb-1">Live job service data / reports</li>
            <li className="mb-1">Time clock management</li>
          </ol>
        </div>
        <div className=" mt-8 lg:mt-4">
          <h5 className="text-landing-page-black font-bold">
            In-Field Portal - Mobile App
          </h5>
          <ol className="list-disc text-landing-page-black list-inside mt-4 font-normal">
            <li className="mb-1">Select route and log job details</li>
            <li className="mb-1">Track materials used/time</li>
            <li className="mb-1">Track hours and clock in</li>
          </ol>
        </div>
      </div>
      <img className="m-auto md:mt-8 px-2 lg:px-0" src={DesktopMobileApp} />
      <div className="flex flex-col items-center mt-10 lg:mt-20 px-2">
        <CTA />
      </div>
    </>
  );
};
const BestLawnCareSection = () => {
  return (
    <div className="flex flex-col lg:min-h-[600px]">
      <MaxWidth>
        <h2
          className="home-header text-snow-white font-extrabold mt-4 uppercase text-center "
          style={{ textShadow: "1px 1px 2px #000000" }}
        >
          The Best App For Lawn Care Companies
        </h2>
        <h3
          className=" italic text-snow-white mt-4 text-center lg:text-left font-bold max-w-[1300px]"
          style={{ textShadow: "1px 1px 2px #000000" }}
        >
          "...I have found this program to be incredibly helpful. It is exactly
          what I needed to keep our lawn route organized so I do not have to be
          in the field. I think more people should know about this, it has
          really helped us..."
        </h3>
        <h3
          className=" font-bold italic text-snow-white mt-1 text-center lg:text-left lg:ml-10"
          style={{ textShadow: "1px 1px 2px #000000" }}
        >
          - Dan H
        </h3>
      </MaxWidth>
    </div>
  );
};
const HurdlesSection = () => {
  return (
    <div className="p-8 py-16 z-10 relative flex flex-col items-center">
      <div className="flex flex-col">
        <h3 className="home-header text-snow-white font-bold text-center inline-block">
          What Hurdles Is Your Business Facing?
        </h3>
        <ul
          className="mt-4 list-disc text-snow-white inline-block font-normal"
          style={{ listStylePosition: "inside" }}
        >
          <li>
            <h4 className="inline  text-snow-white">Disorganized paperwork?</h4>
          </li>

          <li>
            <h4 className="inline text-snow-white">
              Trouble managing subcontractors?
            </h4>
          </li>
          <li>
            <h4 className="inline text-snow-white">
              Can't get yourself out of the field?
            </h4>
          </li>
          <li>
            <h4 className="inline text-snow-white">
              Need to track progress and profitability?
            </h4>
          </li>
          <li>
            <h4 className="inline text-snow-white">
              Can't accurately track employee hours?
            </h4>
          </li>
          <li>
            <h4 className="inline text-snow-white">Slip and fall lawsuits?</h4>
          </li>
          <li>
            <h4 className="inline text-snow-white">
              Clients disputing services with no proof to back up your work?
            </h4>
          </li>
        </ul>
      </div>
      <h4 className=" text-snow-white font-bold text-center mt-4">
        SnowScape Can Help!
        <br />
        Take our{" "}
        <a
          href="https://info.mysnowscape.com/quiz-landing-page"
          className="underline"
        >
          Business Health Quiz
        </a>{" "}
        today!
      </h4>
    </div>
  );
};
// const TestimonialSection = () => {
//   return (
//     <div className="p-8 py-16 z-10 flex items-center gap-20  justify-center">
//       <img src={Man} />
//       <p className="max-w-[600px] text-2xl">SnowScape revolutionized our business.  When a snow storm hits I can see where all my crew are and what still needs done. It's a lifesaver!<br /><br />John Smith<br /><span className="text-[#cccccc] text-sm" style={{ position: 'relative', top: '-12px'}} >Snow Removal LLC.</span></p>
//     </div>
//   );
// };
const CTA = ({ className }) => {
  return (
    <ButtonLink
      to="/sign-up"
      className={`max-w-[300px]  font-bold ${className ?? ""}`}
    >
      Start Free Today
    </ButtonLink>
  );
};
const IntroductionSection = ({ popupClicked }) => {
  return (
    <>
      <div className="max-w-[2000px] m-auto flex flex-col lg:flex-row lg:mb-10 introduction-section">
        <div className=" flex flex-col w-full items-center lg:py-20">
          <h1
            className="home-header text-snow-white font-bold leading-tight text-center mt-10 lg:mt-0 max-w-[1500px]"
            style={{ textShadow: "1px 1px 2px #000000" }}
          >
            Track jobs, routes, crews, and materials—all in one place.
            <br />
            Transform Your Landscaping Business With Free Real-Time Tracking &
            Streamlined Operations
          </h1>
          <h2
            className=" text-snow-white mt-4 text-center lg:font-normal"
            style={{ lineHeight: "1.5rem", textShadow: "1px 1px 2px #000000" }}
          >
            Say bye paperwork and hello fast efficiency.
            <br /> Our users are saving up to{" "}
            <span className="font-bold">$10,000</span> a month
          </h2>
          <CTA className="mt-10" />
          <div className="mt-1">
            <a
              href="#"
              onClick={popupClicked}
              className="italic text-snow-white underline"
              style={{ textShadow: "1px 1px 2px #000000" }}
            >
              Why is it Free?
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center">
        <FeatureHighlight />
        <h3
          className=" text-snow-white mt-6 text-center font-bold"
          style={{ textShadow: "1px 1px 2px #000000" }}
        >
          Created by Landscapers for Landscapers
        </h3>
      </div>
    </>
  );
};
const FeatureCard = ({ icon: Icon, title, children, className }) => {
  return (
    // <div className="bg-gradient-to-b from-[#10222F] -mx-8 lg:mx-0 p-8 rounded-lg">
    // <div className="lg:bg-gradient-to-b lg:from-[#152c3d] bg-[#152c3d] lg:bg-transparent -mx-8 lg:mx-0 p-8 rounded-lg">
    <div
      className={`bg-gradient-to-b from-[#254d6b] bg-[#101113] mx-0 p-6 rounded-lg border border-[#576c7e] ${className ?? ""}`}
    >
      <div className="flex items-center sm:items-start flex-row">
        <div className="w-1/3 flex flex-col items-center justify-between">
          <img src={Icon} alt={title} className="mr-4" />
          {/* <div className="bg-[#2b3942] p-8 rounded-xl ">
            <img src={Icon} alt={title} className="w-8 h-8" />
          </div> */}
        </div>
        <div className="w-full sm:w-2/3">
          <h2 className=" font-bold text-snow-white mt-0">{title}</h2>
          <p className="text-snow-white font-light text-sm">{children}</p>
        </div>
      </div>
    </div>
  );
};
const FeatureHighlight = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-8 mt-8 lg:mt-20 max-w-[1818px] m-auto">
      <FeatureCard title="Real-Time Crew Tracking" icon={MapIcon}>
        Know where your teams are at all times so that you can save time and be
        more efficient.
      </FeatureCard>
      <FeatureCard title="Job & Material Management" icon={SnowRemovalIcon}>
        Keep tabs on job progress and material usage to regain control of your
        business, saving money, time and stress.
      </FeatureCard>
      <FeatureCard title="Simplified Billing" icon={SpreadsheetIcon}>
        Accurate records mean faster invoicing and fewer disputes - our clients
        save on average $10,000 just by using SnowScape.
      </FeatureCard>
      <FeatureCard title="Dynamic Site Maps" icon={SiteMapIcon}>
        Our powerful site map editor makes quotes easy and crews happy.
      </FeatureCard>
    </div>
  );
};
const PricingSection = () => {
  const navigate = useNavigate();
  return (
    <div id="pricing" className="flex flex-col items-center">
      <h2 className="home-header mb-4 text-snow-white font-bold mt-4 text-center">
        Our Pricing
      </h2>
      <div className="max-w-6xl">
        <Pricing
          buttonText="Get Started"
          onPlanSelect={(plan) => {
            navigate(`/sign-up?plan=${plan}`);
          }}
        />
      </div>
    </div>
  );
};
const WhyChooseUsSection = () => {
  return (
    <>
      <h2
        className="home-header text-snow-white font-bold mt-4 text-center lg:mt-20"
        id="features"
      >
        Why Choose Us?
      </h2>

      <h4 className=" text-snow-white lg:text-center max-w-6xl mx-auto mt-4">
        As landscape business owners ourselves, we understand the hurdles and
        growing pains you face when trying to organize, grow, and scale your
        business. We've been through these growing pains and developed SnowScape
        to take the tracking, route planning, and organization hurdles out of
        your operations. Learn from us.{" "}
        <span className="text-[#46b610]">
          With SnowScape you're getting the support of green industry business
          owners that have been in your shoes.
        </span>{" "}
        And have made it to the other side.
      </h4>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8 lg:mt-20 max-w-[1818px] m-auto">
        <VideoCard
          url="https://www.youtube-nocookie.com/embed/hyiInDmCzHw?si=kVs8eZ9ev7LCguv-"
          title="Protect"
          icon={ShieldIcon}
        >
          With time stamped reports and pictures, there is never a guess as to
          what was done at the job site and when.
        </VideoCard>
        <VideoCard
          url="https://www.youtube.com/embed/dtHFxejiSv0?si=YekuA76oi4XC9dLG"
          title="Manage"
          icon={GearIcon}
          className="border-full-black border"
        >
          Create routes with all the details you need for each individual job.
          From site maps, to lock combinations, and everything in between!
        </VideoCard>
        <VideoCard
          url="https://www.youtube-nocookie.com/embed/LDLuEJPhqfk?si=v53nXtpSANwLm1ZT"
          title="Streamline"
          icon={MergeIcon}
        >
          Everything is in one place. With a super siple platform, little to no
          training is needed. Even the most technologically illiterate person
          can figure it out.
        </VideoCard>
      </div>

      <h2
        className="home-header text-snow-white font-bold mt-4 text-center lg:mt-20"
        id="features"
      >
        Feature List
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8 lg:mt-20 max-w-[1818px] m-auto">
        <ul className="list-disc ml-8 mt-2">
          <li>Protection from slip and fall liability</li>
          <li>
            Reduce exposure to slip and falls with picture documentation of all
            services rendered (time stamped)
          </li>
          <li>Unlimited job sites</li>
          <li>Ability to grow with you and your staff</li>
          <li>Affordable service packages for all company sizes</li>
          <li>Service reports to protect from billing disputes</li>
          <li>
            Service reports that automatically record the weather conditions
          </li>
        </ul>
        <ul className="list-disc ml-8 mt-2">
          <li>Create and customize routes year round</li>
          <li>Unlimited service reports emailed upon completion of a job</li>
          <li>Unlimited picture documentation</li>
          <li>Job history report generating</li>
          <li>Tracking materials used</li>
          <li>Tracking of time spent at each job</li>
          <li>Payroll reports</li>
          <li>TimeClock management</li>
          <li>Customizable notes for each job</li>
          <li>Customizable site maps for each job</li>
          <li>Crews can flag issues as urgent</li>
        </ul>
        <ul className="list-disc ml-8 mt-2">
          <li>Everything in one place</li>
          <li>Simple and user friendly</li>
          <li>Month to month payment terms</li>
          <li>Eliminate paperwork</li>
          <li>Real time reporting of services being performed</li>
          <li>Site maps to specify job site parameters</li>
          <li>Ability to track subcontractors</li>
          <li>
            A customizable report generator to give you all the data you need to
            bid jobs properly and bill accurately
          </li>
          <li>Option to send service report directly to clients</li>
        </ul>
      </div>
    </>
  );
};
const LearnMoreSection = () => {
  return (
    <>
      <h2 className="home-header mb-4 text-snow-white font-bold mt-4 text-center">
        Learn More
      </h2>
      <h3 className=" text-snow-white lg:text-center">
        Tell us just a little bit about yourself. <br />
        Fill out this form below to learn more about the app, desktop version,
        or to talk to one of the founders!
      </h3>
      <h4 className=" text-snow-white lg:text-center max-w-6xl mx-auto mt-12 lg:mt-4">
        The best part about SnowScape is that it was developed and is run by two
        landscape company owners. We would be happy to talk shop, or help with
        your business operation. We created SnowScape to help us grow and scale
        the operations of our landscape business. When we first started to grow,
        we only wish we had a tool available to us like SnowScape. If you're
        just starting that journey and are a solo owner/operator, we want to
        make sure you have this tool to help get you over the hump and beyond so
        you can achieve your dreams of a business that runs like a well oiled
        machine.
      </h4>
      {/* FORM GOES HERE */}
      <div className="flex-1 h-[900px] lg:h-[700px] mt-10">
        <iframe
          src="https://api.leadconnectorhq.com/widget/form/44RozebCQVZCHS4I1zYJ"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            borderRadius: "3px",
          }}
          id="inline-44RozebCQVZCHS4I1zYJ"
          data-layout="{'id':'INLINE'}"
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="CTA 1"
          data-height="664"
          data-layout-iframe-id="inline-44RozebCQVZCHS4I1zYJ"
          data-form-id="44RozebCQVZCHS4I1zYJ"
          title="CTA 1"
        ></iframe>
        <script src="https://link.msgsndr.com/js/form_embed.js"></script>
      </div>
    </>
  );
};

export default HomePage;
